// import colors from 'vuetify/es5/util/colors';

export default {
  primary: '#0075bc',
};
